import { render, staticRenderFns } from "./PsConfigurationRatesGroup.vue?vue&type=template&id=5ac5aeab&scoped=true&"
import script from "./PsConfigurationRatesGroup.vue?vue&type=script&lang=js&"
export * from "./PsConfigurationRatesGroup.vue?vue&type=script&lang=js&"
import style0 from "./PsConfigurationRatesGroup.vue?vue&type=style&index=0&id=5ac5aeab&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac5aeab",
  null
  
)

export default component.exports